webpackJsonp([262171880954565],{

/***/ 871:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"title":"QEMU 3.0 Released","createdAt":"20 hours ago","by":"pyprism","comments":[{"text":"Cool! Qemu + binfmt is magic","by":"xkcd-sucks","timeISO":"12 hours ago"}]}}

/***/ })

});


// WEBPACK FOOTER //
// path---comment-17767366-c2cecf6d97f061677d04.js